class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();

      const shopifyLocale = `${window.Shopify.locale}-${window.Shopify.country}`;

      if (shopifyLocale === 'en-GB') {
        this.getCartContents().then((data) => { // request cart contents then write data to notification if needed
          const freeShipping = document.querySelector('.cart-notification__free-shipping');
          const freeShippingData = freeShipping.dataset;
          const minCartValueForFreeShipping = freeShippingData.minCartValue;
          const underThresholdMsg = freeShippingData.underThresholdMsg;
          const aboveThresholdMsg = freeShippingData.aboveThresholdMsg;
          const cartSubtotal = data.items_subtotal_price;
          const shippingDifference = minCartValueForFreeShipping - cartSubtotal;
          const shopifyLocale = `${window.Shopify.locale}-${window.Shopify.country}`;
          const currentCurrency =  window.Shopify.currency.active;

          if (shopifyLocale && currentCurrency) {
            if (shippingDifference < 0) { // cart applicable for free shipping
              freeShipping.innerHTML = `<strong>${aboveThresholdMsg}</strong>`;
            } else { // cart not applicable for free shipping
              // format the shipping difference to currency using .toLocaleString() for UK
              const shippingDifferenceFormatted = (shippingDifference / 100).toLocaleString(shopifyLocale, { style: 'currency', currency: window.Shopify.currency.active });
              let freeShippingHTML = underThresholdMsg.replace('|||amount|||', `<strong>${shippingDifferenceFormatted}</strong>`);
    
              // calculate the percentage of the cart value to the min cart value for free shipping
              const percentageOfMinCartValue = ((minCartValueForFreeShipping - shippingDifference) / (minCartValueForFreeShipping)) * 100;
              freeShippingHTML += `<div class="cart-notification__free-shipping-track"><div class="cart-notification__free-shipping-status" style="width: ${percentageOfMinCartValue}%"></div></div>`;
              freeShipping.innerHTML = freeShippingHTML;
            }

            if (window.Spiral.updateUtilityFreeShipping) {
              window.Spiral.updateUtilityFreeShipping(minCartValueForFreeShipping - shippingDifference);
            }
          }
        });
      }

      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  // getCartContents as a async function
  async getCartContents() {
  const response = await fetch(`/cart.js`, {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'GET'
  });

  return response.json();
  };
  
  renderFreeDeliveryMessage(data) {
    // find the div .cart-notification__free-shipping and get all of the data attributes then write the shipping difference to the div
    const freeShipping = document.querySelector('.cart-notification__free-shipping');

    const freeShippingData = freeShipping.dataset;
    const minCartValueForFreeShipping = freeShippingData.minCartValue;
    const underThresholdMsg = freeShippingData.underThresholdMsg;
    const aboveThresholdMsg = freeShippingData.aboveThresholdMsg;

    const cartSubtotal = data.items_subtotal_price;

    const shippingDifference = minCartValueForFreeShipping - cartSubtotal;

    if (shippingDifference < 0) { // cart applicable for free shipping
      freeShipping.innerHTML = `<strong>${aboveThresholdMsg}</strong>`;
    } else { // cart not applicable for free shipping
      // format the shipping difference to currency using .toLocaleString() for UK
      const shippingDifferenceFormatted = (shippingDifference / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
      let freeShippingHTML = underThresholdMsg.replace('|||amount|||', `<strong>${shippingDifferenceFormatted}</strong>`);
      
      // calculate the percentage of the cart value to the min cart value for free shipping
      const percentageOfMinCartValue = ((minCartValueForFreeShipping - shippingDifference) / (minCartValueForFreeShipping)) * 100;
      freeShippingHTML += `<div class="cart-notification__free-shipping-track"><div class="cart-notification__free-shipping-status" style="width: ${percentageOfMinCartValue}%"></div></div>`;
      freeShipping.innerHTML = freeShippingHTML;
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
